import React from 'react';
import { createPortal } from 'react-dom';

const AdyenModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]"
      onClick={onClose}
    >
      <div className="max-h-[90vh] overflow-y-auto">
        <div
          id="dropin-container"
          className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative flex flex-col"
          onClick={e => e.stopPropagation()}
        >
          {/* Spinner Overlay */}
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75">
            <div className="spinner"></div>
          </div>

          {/* Spacer to ensure the trust row is at the bottom */}
          <div className="mt-auto">
            {/* Trust Rows */}
            <div className="border-t pt-4">
              <div className="mt-2 text-center text-sm text-gray-600">
                Donations are processed securely through PCI DSS certified payment gateway.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AdyenModal;